var sLOG_SOURCE = "Common.JS.";
var sWEB_UPLOAD_FOLDER = '/bluaul.net.upload/';
var sJPICKER_IMAGES = '/bluaul.net/scripts/jPicker/images/';
// Useragent RegExp
var rwebkit = /(webkit)[ \/]([\w.]+)/i;
var rchrome = /(chrome)[ \/]([\w.]+)/i;
var ropera = /(opera)(?:.*version)?[ \/]([\w.]+)/i;
var rmsie = /(msie) ([\w.]+)/i;
var rmozilla = /(mozilla)(?:.*? rv:([\w.]+))?/i;
var _iBrowserWidth;
var _iBrowserHeight;
var _sBrowserAgent;
var _sBrowserVersion;
var iMINTBROWSERHEIGHT = 990;

_iBrowserWidth = $(window).width();
_iBrowserHeight = $(window).height();

_iBrowserHeight = window.innerHeight ? window.innerHeight  : $(window).height();

// *** GLOBAL FUNCTION FOR FADING IN CONTENT
// *****************************************
$(document).ready(function () {
    $("#divContent").fadeIn(500);
    var ua = navigator.userAgent;
    var match = ua.match(rchrome) || ua.match(rwebkit) || ua.match(ropera) || ua.match(rmsie) || ua.indexOf("compatible") < 0 && ua.match(rmozilla) || ['', 'Other', '0.0'];
    _sBrowserAgent = match[1];
    _sBrowserVersion = match[2];
});


//main JS error function
function writeError(sSource, err) {

    var sTask;
    if (typeof err === "undefined") {
        sTask = "Undefined error";
    } else {
       
        if (typeof err.description === "undefined") {
            sTask = "Undefined Error (" + err + ")";
        } else {
            sTask = err.description;
        }
    }

   window.VisualCoreService.writeJSError(sSource, sTask);
}


function setMainContentHeight(content, obj, hRest, staticHeight, bHideYScroll) {
    /// <summary>
    /// This function sets a dynamic content height based on the browser height and removes the body y-scrollbar . <br/>
    /// Under a height limit a static height is set.
    /// </summary>
    var height;
    try {
        //zoom
        ////https://codepen.io/reinis/pen/RooGOE
        staticHeight = 800;
      
        var browserH = _iBrowserHeight;
        if (navigator.userAgent.indexOf("iPad") > -1) {
          
            browserH += 80;
        }

        height = parseInt(browserH, 10) - 10;
       
        if (height > iMINTBROWSERHEIGHT) {
            
            obj.css("min-height", height - hRest);
            content.css("min-height", 550);
            if (bHideYScroll) {$("body").css("overflow-y", "hidden");}
        } else {
            obj.height(parseInt(staticHeight));
        }
    } catch (ex) {
        writeError(sLOG_SOURCE + "setMainContentHeight", ex);
    }
}



function getMousePosition(e) {
   
    try {
        if (e === undefined) e = window.event;
        if (e.pageX || e.pageY) {
            mouse_x_pos = e.pageX; mouse_y_pos = e.pageY;
        } else if (e.clientX || e.clientY) {
            mouse_x_pos = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            mouse_y_pos = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
    } catch (ex) {
        writeError(sLOG_SOURCE + "getMousePos-X", ex);
    }
}

//opens a modalPopup window width hidden background
//function includes all popup functionality like closing ...
function showModalPopup(html, width, height) {
    try {

        //Get the screen height and width
        var maskWidth;
        var maskHeight = $(document).height();
        var bodyW = $("body").width();
        var docW = $(document).width();
        if (docW > bodyW) {
            maskWidth = docW;
        } else {
            maskWidth = bodyW;
        }
        //Set height and width to mask to fill up the whole screen
        $('#mask').css({ 'width': maskWidth, 'height': maskHeight });
        //transition effect    
        $('#mask').fadeIn(500);
        $('#mask').fadeTo("slow", 0.8);
        //Get the window height and width
        var winH = $(window).height();
        var posCurrent = $(window).scrollTop();
        //set size
        $("#modalPopup").width(width).height(height);
        $("#modalPopupContent").width(width - 20).height(height - 20);
        //readjust if top is too high
        var popupTop = parseInt(posCurrent + (winH / 2 - $("#modalPopup").height() / 2), 10);
        if (popupTop <= 0) {
            popupTop = 5;
        }
        var popupWidth = $("#modalPopup").width();
        var popupLeft = (maskWidth) / 2 - popupWidth / 2;
        if (popupLeft <= 0) {
            popupLeft = 5;
        }
        //Set the popup window to center
        $("#modalPopup").css('top', popupTop);
        $("#modalPopup").css('left', popupLeft);
        //set content
        $("#modalPopupContent").html(html);
        //transition effect
        $("#modalPopup").fadeIn(500);
        //if close button is clicked
        $('#modalPopup .modalClose').unbind('click').click(function (e) {
            //Cancel the link behavior
            e.preventDefault();
            $('#mask, #modalPopup').fadeOut(500);
        });
        //if mask is clicked
        $('#mask').unbind('click').click(function () {
            $(this).fadeOut(500);
            $('#modalPopup').fadeOut(500);
        });
    } catch (ex) { writeError(sLOG_SOURCE + "showModalPopup", ex); }
}

//opens a modalPopup as iframe window width hidden background
function showModalIframePopup(src, width, height) {
    showModalPopup("<iframe id='iFramePopup' src='" + src + "'  frameborder='0' scrolling='no' width='" + width + "px' height='" + height + "px' />", width + 40, height + 40);
}

function initUICalendar(id) {
    try {
        $(id).datepicker({ changeMonth: true, changeYear: true, showButtonPanel: true, showOn: 'both', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true });
    } catch (ex) { writeError(sLOG_SOURCE + "initUICalendar", ex); }
}

function initUIDatetimepicker(id) {
    try {
        $(id).datetimepicker({ changeMonth: true, changeYear: true, showButtonPanel: true, showOn: 'both', buttonImage: '../../images/visualcore/calendar.gif', buttonImageOnly: true });
    } catch (ex) { writeError(sLOG_SOURCE + "initUIDatetimepicker", ex); }
}

function ColorPicker(input) {
    input.jPicker({
        window: { expandable: true },
        images: { clientPath: sJPICKER_IMAGES },
        localization:
		{
            text:
            {
                title: window._RESOURCES.JS_Com.chooseColor_lbl,
                newColor: window._RESOURCES.JS_Com.new_lbl,
                currentColor: window._RESOURCES.JS_Com.current_lbl,
                ok: window._RESOURCES.JS_Com.OK_lbl,
                cancel: window._RESOURCES.JS_Com.cancel_lbl
            }
		}
    });
}


function isDate(dateStr) {
    var datePat = /^(\d{1,2})(\/|.)(\d{1,2})(\/|.)(\d{4})$/;
    var matchArray = dateStr.match(datePat); // is the format ok?
    if (matchArray === null) {
        //alert("Please enter date as either mm/dd/yyyy or mm-dd-yyyy.");
        return false;
    }
    var day = matchArray[1]; // p@rse date into variables
    var month = matchArray[3];
    var year = matchArray[5];
    if (month < 1 || month > 12) { // check month range
        //alert("Month must be between 1 and 12.");
        return false;
    }
    if (day < 1 || day > 31) {
        //alert("Day must be between 1 and 31.");
        return false;
    }
    if ((month === 4 || month === 6 || month === 9 || month === 11) && day === 31) {
        //alert("Month "+month+" doesn`t have 31 days!")
        return false;
    }
    if (month === 2) { // check for february 29th
        var isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
        if (day > 29 || (day === 29 && !isleap)) {
            //alert("February " + year + " doesn`t have " + day + " days!");
            return false;
        }
    }
    return true; // date is valid
}

function getCurrentTimestamp() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    var yyyy = today.getFullYear();
    if (dd < 10) { dd = '0' + dd; }
    if (mm < 10) { mm = '0' + mm; }
    if (h < 10) { h = '0' + h; }
    if (m < 10) { m = '0' + m; }
    if (s < 10) { s = '0' + s; }
    return dd + '.' + mm + '.' + yyyy + ' ' + h + ':' + m + ':' + s;
}

function getNode(link) {
    location.href = link;
}

function trimAll(strValue) {
    if (strValue === null) { return ""; }
    var objRegExp = /^(\s*)$/;
    //check for all spaces
    if (objRegExp.test(strValue)) {
        strValue = strValue.replace(objRegExp, '');
        if (strValue.length === 0)
            return strValue;
    }
    //check for leading & trailing spaces
    objRegExp = /^(\s*)([\W\w]*)(\b\s*$)/;
    if (objRegExp.test(strValue)) {
        //remove leading and trailing whitespace characters
        strValue = strValue.replace(objRegExp, '$2');
    }
    return strValue;
}

function rightTrim(strValue) {
    if (strValue === null) { return ""; }
    var objRegExp = /^([\w\W]*)(\b\s*)$/;
    if (objRegExp.test(strValue)) {
        //remove trailing a whitespace characters
        strValue = strValue.replace(objRegExp, '$1');
    }
    return strValue;
}

function leftTrim(strValue) {
    if (strValue === null) { return ""; }
    var objRegExp = /^(\s*)(\b[\w\W]*)$/;
    if (objRegExp.test(strValue)) {
        //remove leading a whitespace characters
        strValue = strValue.replace(objRegExp, '$2');
    }
    return strValue;
}

function validateNotEmpty(strValue) {
    if (strValue === null) { return ""; }
    /*True if valid, otherwise false.*/
    var strTemp = strValue;
    strTemp = trimAll(strTemp);
    if (strTemp.length > 0) {
        return true;
    }
    return false;
}

function validateNumeric(strValue) {
    /*****************************************************************
	DESCRIPTION: Validates that a string contains only valid numbers. */
    var objRegExp = /(^-?\d\d*\,\d*$)|(^-?\d\d*$)|(^-?\,\d\d*$)/;

    //check for numeric characters
    return objRegExp.test(strValue);
}

function validateInteger(strValue) {
    /************************************************
	DESCRIPTION: Validates that a string contains only valid integer number.*/
    var objRegExp = /(^-?\d\d*$)/;

    //check for integer characters
    return objRegExp.test(strValue);
}

function validatePhone(strValue) {
    /************************************************
	DESCRIPTION: Validates that a string contains only valid integer number.*/
    var objRegExp = /(^-?\d\d*$)/;

    //check for integer characters
    return objRegExp.test(strValue);
}

function validateEmail(strValue) {
    /************************************************
    DESCRIPTION: Validates that a string contains a
      valid email pattern.*/
    var objRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    //check for valid email
    return objRegExp.test(strValue);
}

function validateUrl(strValue) {
    /************************************************
    DESCRIPTION: Validates that a string contains a
      valid email pattern.*/
    var objRegExp = /^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/;

    //check for valid email
    return objRegExp.test(strValue);
}

function validateTime(strValue) {
    if (strValue.length < 5) return false;
    if (strValue.length > 5) return false;
    var x = strValue.indexOf(":");
    if (x < 0) { return false;}
    if (
        (strValue.substr(0, 2) >= 0) &&
        (strValue.substr(0, 2) < 24) &&
        (strValue.substr(3, 2) >= 0) &&
        (strValue.substr(3, 2) <= 59)
    ) return true;

    return false;
}

function getFormErrorMsg(errorid) {
    switch (errorid) {
        case 1: return window._RESOURCES.JS_Com.ERR_missingField_lbl; //"Bitte füllen Sie dieses Feld aus!";
        case 2: return window._RESOURCES.JS_Com.ERR_minInput_inc; //"Geben Sie bitte mind.";
        case 3: return window._RESOURCES.JS_Com.ERR_maxInput_inc; //"Geben Sie bitte maximal";
        case 4: return window._RESOURCES.JS_Com.ERR_signs_inc; //"Zeichen ein!";
        case 5: return window._RESOURCES.JS_Com.ERR_validEmail_lbl; //"Bitte geben Sie eine gültige Email-Adr. ein!";
        case 6: return window._RESOURCES.JS_Com.ERR_validURL_lbl; //"Bitte geben Sie eine gültige Url ein!";
        case 7: return window._RESOURCES.JS_Com.ERR_validTelephone_lbl; //"Bitte geben Sie eine gültige Tel-Nr. ein!";
        case 8: return window._RESOURCES.JS_Com.ERR_validNumber_lbl; //"Bitte geben Sie eine gültige Zahl ein!";
        case 9: return window._RESOURCES.JS_Com.ERR_greaterNumber_inc; //"Bitte geben Sie eine Zahl größer";
        case 10: return window._RESOURCES.JS_Com.ERR_lowerNumber_inc; //"Bitte geben Sie eine Zahl kleiner";
        case 11: return window._RESOURCES.JS_Com.ERR_input_inc; //"ein!";
        case 12: return window._RESOURCES.JS_Com.ERR_invalidDate_lbl; // "Bitte geben Sie ein gültiges Datum ein!";
        case 13: return window._RESOURCES.JS_Com.ERR_invalidTime_lbl; // "Bitte geben Sie ein gültiges Datum ein!";
    }
    return "";
}

function resizeIframe(obj) {
  
    obj.style.height = (parseInt(obj.contentWindow.document.body.scrollHeight) + 40) + 'px';
}

function getHighestZIndex() {
    /* Returns the current highest Z-Index */
    var z = 0;
    $("body *").each(function () {
        if ($(this).css("z-index") > z && $(this).css("z-index") !== "auto")
            z = $(this).css("z-index");
    });
    return parseInt(z);
}

function downloadMediaDataUrl(filepath) {
    // _gwa_
    /* Asynchronous Ajax-Call to download media via DataURL, requirers relative MediaPath */

    var mimeType = "";
    var xhr = new XMLHttpRequest();
    // ReSharper disable once AssignedValueIsNeverUsed
    var filename = "";

    filepath = filepath.split("\\").join("/");
    
    filename = filepath.split("/")[filepath.split("/").length - 1];
    filepath = replaceBadQueryStringChars(filepath);

    xhr.responseType = "text";
    // ReSharper disable once StringConcatenationToTemplateString
    xhr.open("GET", "../../webservice/upload/MediaDataUrlHandler.ashx?p=" + filepath);
    xhr.addEventListener("load", function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            mimeType = xhr.responseText.split(";base64,")[0].split(":")[1];

            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            download(xhr.responseText, filename, mimeType);
        } else {
            writeError("Common.js - downloadMediaDataUrl(): ", xhr.stauts + " " + xhr.responseText);
        }
    });
    xhr.send();
}

function getMediaDataUrl(filepath) {
    // _gwa_
    /* Synchronous Ajax-Call to get media as DataURL, requirers relative MediaPath */
    filepath = filepath.split("\\").join("/");
    filepath = replaceBadQueryStringChars(filepath);

    var src = "";
    var xhr = new XMLHttpRequest();

    xhr.open("GET", "../../webservice/upload/MediaDataUrlHandler.ashx?p=" + filepath, false);
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 300) {
        src = xhr.responseText;
    } else {
        writeError("Common.js - downloadMediaDataUrl(): ", xhr.stauts + " " + xhr.responseText);
    }
    return src;
}

function replaceBadQueryStringChars(querystring) {
    querystring = querystring.split("%").join("%25");
    querystring = querystring.split("<").join("%3C");
    querystring = querystring.split(">").join("%3E");
    querystring = querystring.split("#").join("%23");
    querystring = querystring.split("{").join("%7B");
    querystring = querystring.split("}").join("%7D");
    querystring = querystring.split("|").join("%7C");
    querystring = querystring.split("\\").join("%5C");
    querystring = querystring.split("^").join("%5E");
    querystring = querystring.split("~").join("%7E");
    querystring = querystring.split("[").join("%5B");
    querystring = querystring.split("]").join("%5D");
    querystring = querystring.split("`").join("%60");
    querystring = querystring.split(";").join("%3B");
    querystring = querystring.split("/").join("%2F");
    querystring = querystring.split("?").join("%3F");
    querystring = querystring.split(":").join("%3A");
    querystring = querystring.split("@").join("%40");
    querystring = querystring.split("=").join("%3D");
    querystring = querystring.split("&").join("%26");
    querystring = querystring.split("$").join("%24");

    return querystring;
}

function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
}

// Fix: Allow interaction with dynamically loaded content inside modal dialogs.
// Only dialogs with dialogClass "modal-popup-dialog" (the large content popups
// used by chart-click-handler, plausibility, tickets, etc.) get the relaxed
// focus handling.  Small confirmation dialogs (saveDialog, delDialog, askDialog)
// keep the default jQuery UI focus-trap so that Tab cannot escape them.
if ($.ui && $.ui.dialog) {
    $.widget("ui.dialog", $.ui.dialog, {
        _allowInteraction: function (event) {
            // Always allow datepicker interaction (shared across all dialogs)
            if ($(event.target).closest(".ui-datepicker").length) {
                return true;
            }
            // For large content dialogs: allow any interaction inside any
            // .ui-dialog container (covers dynamically loaded jqGrid forms,
            // plausibility detail inputs, etc.)
            if (this._hasRelaxedFocus()) {
                if ($(event.target).closest(".ui-dialog").length) {
                    return true;
                }
            }
            return this._super(event);
        },
        _createOverlay: function () {
            this._super();
            // Only remove the focusin trap for large content dialogs
            if (this.options.modal && this._hasRelaxedFocus()) {
                this._off(this.document, "focusin");
            }
        },
        _hasRelaxedFocus: function () {
            // Returns true only for dialogs that use the "modal-popup-dialog"
            // dialogClass — these are the large popups that load visuals
            // dynamically (vcMenuTemplate editDialog, chart-click-handler, etc.)
            var cls = this.options.dialogClass || "";
            return cls.indexOf("modal-popup-dialog") !== -1;
        }
    });
}